import React, { Component } from 'react';
import { connect } from 'react-redux';
import { loaderStateTrue, loaderStateFalse, handleActiveLink, connectToWebsocket, disconnectToWebsocket } from './Actions/AllAction';
import { setToken, setUserCredentials, logOutApp } from './GlobalModules/Login/Actions/LoginAction';
import { Tabs, Tab } from 'react-bootstrap';
import ModalGlobal from './GlobalModules/Utility/Components/ModalGlobal'
import ConfirmationAlert from './GlobalModules/Utility/Components/ConfirmationAlert'
import Organization from './GlobalModules/Organization/Organization';
import { withRouter } from 'react-router-dom';
import Users from './GlobalModules/Users/Pages/User/Users';
import Utility from './GlobalModules/Utility/Utility';
import EventEmitter from './GlobalModules/Utility/Components/EventEmitter';
import ErrorBoundary from './GlobalModules/Utility/Components/ErrorBoundary';
import SupportUser from './GlobalModules/SupportUser/SupportUser';
import Test from './GlobalModules/Users/Pages/Test/Test';


class HomePage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedTabName: localStorage.getItem("selectedTabName") && localStorage.getItem("selectedTabName") != "" ? localStorage.getItem("selectedTabName") : this.props.userCredentials.user_details.user_type == "app_admin" ? "organisation" : "user",
            tabcontainerspace: "",
            tabchangeParent: false,
            tabChangeConfirmModal: false,
            tempTabName: "",
            branchId: "",
            quotationConvertBookingObj: {},
            quotationConvertBookingModalFlag: false,
            agentFlag: true,
        }
    }

    //initially check event emitter events and permission wise tab selection
    componentDidMount() {
        this.props.handleActiveLink("home_module", "");
        this.permissionWiseTabSelected();

        this.listener = EventEmitter.addListener("sendMessage", (message, id = "") => {
            if (message == 'quotation') {
                this.setState({
                    selectedTabName: 'quotation',
                    quotationConvertBookingObj: { 'booking_number': id }
                }, () => {
                    this.props.history.push(`/${localStorage.getItem('i18nextLng')}/home/quotation`);
                    this.setState({
                        quotationConvertBookingModalFlag: true
                    })
                })
            }
            if (message == 'booking_room') {
                this.setState({
                    selectedTabName: 'booking_room'
                }, () => {
                    this.props.history.push(`/${localStorage.getItem('i18nextLng')}/home/booking_room`)
                })
            }
            if (message == 'quotation_to_booking') {
                this.setState({
                    selectedTabName: 'booking_room',
                    quotationConvertBookingObj: { 'booking_number': id }
                }, () => {
                    this.props.history.push(`/${localStorage.getItem('i18nextLng')}/home/booking_room`)
                    this.setState({
                        quotationConvertBookingModalFlag: true
                    })
                })
            }

            if (message == 'room_type') {
                this.setState({
                    selectedTabName: 'room_type'
                }, () => {
                    this.props.history.push(`/${localStorage.getItem('i18nextLng')}/home/room_type/${id}`)
                })
            }

            if (message == 'booking_rules') {
                this.setState({
                    selectedTabName: 'booking_rules'
                }, () => {
                    if (id == "0") {
                        this.props.history.push(`/${localStorage.getItem('i18nextLng')}/settings/booking_rules/`)
                    } else {
                        this.props.history.push(`/${localStorage.getItem('i18nextLng')}/settings/booking_rules/${id}`)
                    }
                })
            }
        })
    }

    //when params type does not match selected tab name then select booking tab 
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.match.params.branchId != this.props.match.params.branchId) {
            this.setState({
                branchId: this.props.match.params.branchId
            })
        }

        if (prevProps.match.params.type != this.props.match.params.type) {
            this.setState({
                selectedTabName: this.props.match.params.type ? this.props.match.params.type : 'booking_room'
            })
        }
    }

    //tab selection css
    setTabConatinerSpaceClass = (className) => {
        this.setState({
            tabcontainerspace: className
        })
    }

    detectChangesIndividualTab = (value = false) => {
        this.setState({
            tabchangeParent: value
        })
    }

    //tab change confirmation modal open fn
    openTabChangeConfirmModal = () => {
        this.setState({
            tabChangeConfirmModal: true
        })
    }

    //tab change confirmation modal close fn
    tabChangeConfirmModalHide = () => {
        this.setState({
            tabChangeConfirmModal: false,
            tempTabName: ""
        })
    }

    //tab change slection fn
    handelSelectTab = (tabName) => {
        if (this.state.tabchangeParent == true) {
            let saveData = localStorage.setItem("selectedTabName", tabName);
            this.setState({
                tempTabName: tabName
            }, () => {
                this.openTabChangeConfirmModal()
                this.confirmTabChange()
            })
        } else {
            let saveData = localStorage.setItem("selectedTabName", tabName);
            this.setState({
                selectedTabName: tabName
            }, () => {
                this.props.history.push(`/${localStorage.getItem('i18nextLng')}/home/${this.state.selectedTabName}`);
            })
        }
    }
    confirmTabChange = () => {
        this.setState({
            selectedTabName: this.state.tempTabName
        }, () => {
            this.cancelTabChange()
            this.setState({
                tabchangeParent: false
            })
        })
    }
    cancelTabChange = () => {
        this.tabChangeConfirmModalHide()
    }

    //permission wise active tab selection method
    permissionWiseTabSelected = () => {
        const { userCredentials } = this.props;
        if (this.props.match.params.type) {
            this.setState({
                selectedTabName: this.props.match.params.type
            })
        } else {

            let tab_order = ["organisation", "user", "support_user", "demo_page"];
            if (userCredentials?.user_details?.user_type == "app_admin") {
                tab_order = ["organisation", "user", "support_user"]
            }
            if (userCredentials?.user_details?.user_type !== "app_admin") {
                if (userCredentials?.user_details?.is_subscribed == false) {
                    tab_order = ["user"]
                }
            }
            let selectedTabList = tab_order.map((e) => {
                if (Object.keys(Utility.getRoleObjectByEventKey(e)).length > 0) {
                    return e;
                } else {
                    return "";
                }
            })
            let selectedTab = selectedTabList.filter(function (el) {
                return el != "";
            });
            this.setState({
                selectedTabName: selectedTab.length > 0 ? selectedTab[0] : ""
            })
        }
    }

    //tab selection permission wise validation
    validationPermission = (eventKey) => {
        const { t, roleWisePermission } = this.props;
        let valid = false;
        if (roleWisePermission.hasOwnProperty(eventKey) && roleWisePermission[eventKey].read_write_permission != "") {
            valid = true;
        }
        return valid
    }

    // componentDidMount

    tabUi = () => {
        const { t, roleWisePermission, userCredentials } = this.props;
        let arryHash = roleWisePermission;
        let arry = []
        if (userCredentials?.user_details?.user_type == "app_admin") {
            arry.push(
                // <Tab eventKey="organisation" title="Organizations" key={0}>
                //     {this.state.selectedTabName == 'organisation' ?
                //         <Organization detectChangesIndividualTab={this.detectChangesIndividualTab} /> : null}
                // </Tab>
                <Organization detectChangesIndividualTab={this.detectChangesIndividualTab} />
            )
        }

        if (userCredentials?.user_details.user_type == "app_admin") {
            arry.push(
                // <Tab eventKey="user" title={userCredentials?.user_details?.user_type == "app_admin" ? "Admins" : "Staff"} key={1}>
                //     {this.state.selectedTabName == 'user' ?
                //         <Users setTabConatinerSpaceClass={this.setTabConatinerSpaceClass} detectChangesIndividualTab={this.detectChangesIndividualTab} /> : null}
                // </Tab>
                <Users setTabConatinerSpaceClass={this.setTabConatinerSpaceClass} detectChangesIndividualTab={this.detectChangesIndividualTab} />
            )
        }

        if (userCredentials?.user_details.user_type == "app_admin") {
            arry.push(
                // <Tab eventKey="support_user" title="Support User" key={2}>
                //     {this.state.selectedTabName == 'support_user' ?
                //         <SupportUser setTabConatinerSpaceClass={this.setTabConatinerSpaceClass} detectChangesIndividualTab={this.detectChangesIndividualTab} /> : null}
                // </Tab>
                <SupportUser setTabConatinerSpaceClass={this.setTabConatinerSpaceClass} detectChangesIndividualTab={this.detectChangesIndividualTab} />
            )
        }
        if (userCredentials?.user_details.user_type != "app_admin" && (Object.keys(Utility.getRoleObjectByEventKey('demo_page')).length > 0)) {
            arry.push(
                // <Tab eventKey="demo_page" title="Test" key={3}>
                //     {this.state.selectedTabName == 'demo_page' ?
                //         <Test setTabConatinerSpaceClass={this.setTabConatinerSpaceClass} detectChangesIndividualTab={this.detectChangesIndividualTab} /> : null}
                // </Tab>
                <Test setTabConatinerSpaceClass={this.setTabConatinerSpaceClass} detectChangesIndividualTab={this.detectChangesIndividualTab} />
            )
        }

        return arry;
    }

    closeQuotationConvertBookingIdModalFn = () => {
        this.setState({
            quotationConvertBookingModalFlag: false,
            quotationConvertBookingObj: {}
        })
    }


    render() {
        const { t, userCredentials } = this.props;
        const { tabcontainerspace } = this.state;
        return (
            // <div className={`${tabcontainerspace} homepagecontainerBox connectheaderBox`} >
            <div>
                {/* <Tabs
                    id="homepagetabs"
                    activeKey={this.state.selectedTabName}
                    className="tabsmainboxContainer"
                    onSelect={this.handelSelectTab}

                > */}
                {this.tabUi()}
                {/* </Tabs> */}
                <ModalGlobal
                    show={this.state.tabChangeConfirmModal}
                    onHide={this.tabChangeConfirmModalHide}
                    className="modalcustomize confirmationalertmodal"
                    bodyClassName="cancelConfirmationbody"
                    headerclassName="close_btn_icon"
                    title=""
                    footer={false}
                    body={
                        <ConfirmationAlert
                            BodyFirstContent='navigateConfirmation'
                            BodySecondContent=""
                            BodyThirdContent=""
                            confirmationButtonContent='confirm'
                            cancelButtonContent='cancel'
                            deleteConfirmButton={this.confirmTabChange}
                            deleteCancleButton={this.cancelTabChange}
                        />
                    }
                />
            </div >
        );
    }
}




const mapStateToProps = (globalState) => {
    return {
        userCredentials: globalState.LoginReducer.userCredentials,
        token: globalState.LoginReducer.token,
        access_token: globalState.mainReducerData.access_token,
        roleWisePermission: globalState.mainReducerData.roleWisePermission,
    };
}


export default connect(mapStateToProps, { handleActiveLink, setUserCredentials })(withRouter(HomePage));
